export default __webpack_public_path__ + "static/media/boris.f08db882.jpeg";